import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';

function merge(partial) {
  return { ...en, ...partial };
}

export default merge({
  'common.theme': 'المظهر',
  'common.themeLight': 'فاتح',
  'common.themeDark': 'داكن',
  'common.themeActive': 'نشط حالياً',
  'common.themeSwitchToDark': 'التبديل إلى الداكن',
  'common.themeSwitchToLight': 'التبديل إلى الفاتح',
  'common.ariaSwitchToLightTheme': 'التبديل إلى المظهر الفاتح',
  'common.ariaSwitchToDarkTheme': 'التبديل إلى المظهر الداكن',
  'common.ariaToggleMobileSidebar': 'فتح/إغلاق الشريط الجانبي',
  'common.ariaCloseSidebarBackdrop': 'إغلاق الخلفية',
  'common.ariaAccountMenu': 'قائمة الحساب',
  'common.settings': 'الإعدادات',
  'common.loading': 'جاري التحميل…',
  'settings.language': 'اللغة',
  'settings.languagePlaceholder': 'اختر اللغة',
  'settings.savePreferences': 'حفظ التفضيلات',
  'settings.savingPreferences': 'جاري الحفظ…',
  'auth.gate.userTitle': 'جاري التحقق من جلستك',
  'auth.gate.userDescription': 'جاري تأكيد تسجيل الدخول. لحظات فقط.',
  'auth.gate.agentTitle': 'جاري التحقق من جلستك',
  'auth.gate.agentDescription': 'جاري تأكيد دخول الوكيل. لحظات فقط.',
  'auth.page.themeLight': 'فاتح',
  'auth.page.themeDark': 'داكن',
  'auth.page.ariaTheme': 'تبديل المظهر',
  'user.layout.sidebarTitle': 'لوحة مستخدم MineMe',
  'user.layout.investorAccount': 'حساب المستثمر',
  'user.layout.nav.dashboard': 'لوحة التحكم',
  'user.layout.nav.deposit': 'إيداع',
  'user.layout.nav.withdraw': 'سحب',
  'user.layout.nav.investments': 'الاستثمارات',
  'user.layout.nav.referral': 'الإحالات',
  'user.layout.nav.notifications': 'الإشعارات',
  'user.layout.nav.stopLoss': 'وقف الخسارة',
  'user.layout.nav.transactions': 'المعاملات',
  'user.layout.nav.settings': 'الإعدادات',
  'user.layout.logout': 'تسجيل الخروج',
  'user.layout.balance.available': 'الرصيد المتاح',
  'user.layout.balance.frozen': 'الرصيد المجمد',
  'user.layout.balance.interest': 'رصيد الفوائد',
  'user.layout.balance.bonus': 'رصيد المكافأة',
  'user.dashboard.balance.available': 'الرصيد المتاح',
  'user.dashboard.balance.frozen': 'الرصيد المجمد',
  'user.dashboard.balance.interest': 'الفائدة المكتسبة',
  'user.dashboard.balance.bonus': 'رصيد المكافأة',

  'common.time.days': 'أيام',
  'common.time.hours': 'ساعات',
  'common.time.minutes': 'دقائق',
  'common.time.seconds': 'ثوانٍ',

  'user.dashboard.title': 'لوحة التحكم',
  'user.dashboard.loadingInvestments': 'جاري تحميل حالة الاستثمار…',

  'user.dashboard.stats.totalInvested': 'إجمالي الاستثمار',
  'user.dashboard.stats.netPnl': 'صافي الربح / الخسارة',
  'user.dashboard.stats.activePlans': 'الخطط النشطة',

  'user.dashboard.noInvestment.title': 'لا يوجد استثمار نشط',
  'user.dashboard.noInvestment.subtitle':
    'ابدأ الاستثمار اليوم ونمّ ثروتك بعوائد جذابة',
  'user.dashboard.noInvestment.cta': 'استكشف خطط الاستثمار',

  'user.dashboard.recentTx.title': 'المعاملات الأخيرة',
  'user.dashboard.recentTx.viewAll': 'عرض الكل',
  'user.dashboard.recentTx.col.date': 'التاريخ',
  'user.dashboard.recentTx.col.type': 'النوع',
  'user.dashboard.recentTx.col.description': 'الوصف',
  'user.dashboard.recentTx.col.amount': 'المبلغ',
  'user.dashboard.recentTx.col.status': 'الحالة',
  'user.dashboard.recentTx.loading': 'جاري تحميل المعاملات الأخيرة…',
  'user.dashboard.recentTx.empty': 'لا توجد معاملات أخيرة.',

  'user.dashboard.tx.Deposit': 'إيداع',
  'user.dashboard.tx.Investment': 'استثمار',
  'user.dashboard.tx.Referral': 'إحالة',
  'user.dashboard.tx.Bonus': 'مكافأة',
  'user.dashboard.tx.Withdrawal': 'سحب',
  'user.dashboard.tx.E-Voucher': 'قسيمة إلكترونية',
  'user.dashboard.tx.Stop-Loss': 'وقف الخسارة',

  'user.dashboard.st.Completed': 'مكتمل',
  'user.dashboard.st.Active': 'نشط',
  'user.dashboard.st.Pending': 'قيد الانتظار',
  'user.dashboard.st.Failed': 'فشل',

  'user.dashboard.invest.planFallback': 'خطة',
  'user.dashboard.invest.activeBadge': 'نشط',
  'user.dashboard.invest.detail.amountInvested': 'المبلغ المستثمر',
  'user.dashboard.invest.detail.currentValue': 'القيمة الحالية',
  'user.dashboard.invest.detail.pl': 'الربح / الخسارة',
  'user.dashboard.invest.detail.interestRate': 'معدل الفائدة',
  'user.dashboard.invest.detail.perMonth': '{{pct}}٪ شهرياً',
  'user.dashboard.invest.detail.duration': 'المدة',
  'user.dashboard.invest.detail.months': '{{n}} شهراً',
  'user.dashboard.invest.detail.startDate': 'تاريخ البدء',
  'user.dashboard.invest.detail.nextWithdrawal': 'السحب التالي',
  'user.dashboard.invest.countdownTitle': 'السحب التالي خلال',
  'user.dashboard.invest.progress': 'التقدم',
  'user.dashboard.invest.progressPct': '{{pct}}٪ مكتمل',
  'user.dashboard.invest.earlyWithdraw': 'سحب مبكر',
  'user.dashboard.invest.planChip': '{{name}} رقم {{num}}',

  'user.dashboard.invest.modal.title': 'تنبيه السحب المبكر',
  'user.dashboard.invest.modal.investmentAmount': 'مبلغ الاستثمار:',
  'user.dashboard.invest.modal.platformFee': 'رسوم المنصة ({{pct}}٪):',
  'user.dashboard.invest.modal.interestForfeited': 'الفائدة المُتخلّى عنها:',
  'user.dashboard.invest.modal.youWillReceive': 'ستستلم:',
  'user.dashboard.invest.modal.confirmHint': 'اكتب CONFIRM للمتابعة',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'تأكيد السحب',
  'user.dashboard.invest.modal.cancelling': 'جاري الإلغاء…',
  'user.dashboard.invest.toast.cancelled': 'تم إلغاء الاستثمار',
  'user.dashboard.invest.toast.cancelFailed': 'تعذّر الإلغاء',

  'notifications.bell.triggerAria': 'الإشعارات',
  'notifications.bell.title': 'الإشعارات',
  'notifications.bell.loading': 'جاري التحميل…',
  'notifications.bell.loadErrorSubtitle': 'تعذّر تحميل الإشعارات',
  'notifications.bell.unreadOne': 'تحديث واحد غير مقروء',
  'notifications.bell.unreadMany': '{{count}} تحديثات غير مقروءة',
  'notifications.bell.allCaughtUp': 'لا توجد تحديثات جديدة',
  'notifications.bell.markAllRead': 'تعليم الكل كمقروء',
  'notifications.bell.empty': 'لا توجد إشعارات بعد',
  'notifications.bell.emptyError': 'تعذّر تحميل الإشعارات',
  'notifications.bell.viewAll': 'عرض الكل',
  'notifications.bell.markReadAria': 'تعليم كمقروء',
  'notifications.bell.time.justNow': 'الآن',
  'notifications.bell.time.secondsAgo': 'منذ {{n}} ث',
  'notifications.bell.time.minutesAgo': 'منذ {{n}} د',
  'notifications.bell.time.hoursAgo': 'منذ {{n}} س',
  'notifications.bell.time.daysAgo': 'منذ {{n}} ي',

  'user.layout.market.loading': 'جاري تحميل بيانات السوق…',
  'user.layout.market.unavailable': 'تغذية السوق غير متوفرة',
  'user.layout.mobilePanel': 'لوحة',
  'user.layout.portfolioWorkspace': 'مساحة المحفظة',
  'agent.layout.sidebarTitle': 'MineMe وكيل',
  'agent.layout.role': 'حساب الوكيل',
  'agent.layout.nav.dashboard': 'لوحة التحكم',
  'agent.layout.nav.referrals': 'الإحالات',
  'agent.layout.nav.commissions': 'العمولات',
  'agent.layout.nav.team': 'فريقي',
  'agent.layout.nav.transactions': 'المعاملات',
  'agent.layout.nav.withdraw': 'سحب',
  'agent.layout.nav.notifications': 'الإشعارات',
  'agent.layout.nav.settings': 'الإعدادات',
  'agent.layout.withdrawalLogs': 'سجل السحوبات',
  'agent.layout.stats.commission': 'رصيد العمولة',
  'agent.layout.stats.direct': 'إحالات مباشرة',
  'agent.layout.stats.earned': 'الإجمالي المكتسب',
  'agent.layout.workspace': 'مساحة الوكيل',
  'agent.layout.logout': 'تسجيل الخروج',
  'auth.user.login.title': 'دخول المستخدم',
  'auth.user.login.subtitle': 'سجّل الدخول إلى لوحة المستخدم.',
  'auth.user.login.noAccount': 'ليس لديك حساب؟',
  'auth.user.login.createAccount': 'إنشاء حساب',
  'auth.user.login.username': 'اسم المستخدم',
  'auth.user.login.password': 'كلمة المرور',
  'auth.user.login.placeholderUsername': 'أدخل اسم المستخدم',
  'auth.user.login.placeholderPassword': 'أدخل كلمة المرور',
  'auth.user.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.user.login.signIn': 'دخول',
  'auth.user.login.signingIn': 'جاري الدخول…',
  'auth.agent.login.title': 'دخول الوكيل',
  'auth.agent.login.subtitle': 'سجّل الدخول باسم مستخدم وكلمة مرور الوكيل.',
  'auth.agent.login.needAccount': 'تحتاج حساباً؟',
  'auth.agent.login.signUp': 'تسجيل',
  'auth.agent.login.usernameHint':
    'أحرف وأرقام؛ تُتجاهل الشرطات (مثل AGT-00142).',
  'auth.agent.login.placeholderUsername': 'اسم مستخدم الوكيل',
  'auth.agent.login.placeholderPassword': 'كلمة المرور',
  'auth.agent.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.agent.login.signIn': 'دخول',
  'auth.agent.login.signingIn': 'جاري الدخول…',
  'auth.agent.login.ariaShowPassword': 'إظهار كلمة المرور',
  'auth.agent.login.ariaHidePassword': 'إخفاء كلمة المرور',
  'auth.user.forgot.title': 'نسيت كلمة المرور',
  'auth.user.forgot.subtitle': 'أعد التعيين بعبارة الاسترداد المكونة من 12 كلمة.',
  'auth.user.forgot.remember': 'تتذكر كلمة المرور؟',
  'auth.user.forgot.signIn': 'دخول',
  'auth.user.forgot.intro':
    'استخدم نفس اسم المستخدم والبريد وعبارة الاسترداد المحفوظة عند التسجيل. الحسابات القديمة قد لا تدعم هذا المسار.',
  'auth.user.forgot.username': 'اسم المستخدم',
  'auth.user.forgot.email': 'البريد الإلكتروني',
  'auth.user.forgot.recoveryPhrase': 'عبارة الاسترداد',
  'auth.user.forgot.newPassword': 'كلمة مرور جديدة',
  'auth.user.forgot.confirmPassword': 'تأكيد كلمة المرور',
  'auth.user.forgot.submit': 'إعادة تعيين كلمة المرور',
  'auth.user.forgot.submitting': 'جاري إعادة التعيين…',
  'auth.user.forgot.placeholderUsername': 'اسم المستخدم',
  'auth.user.forgot.placeholderEmail': 'بريد الحساب',
  'auth.user.forgot.placeholderRecovery': 'أدخل عبارة الـ12 كلمة',
  'auth.user.forgot.placeholderNew': '8 أحرف على الأقل',
  'auth.user.forgot.placeholderConfirm': 'كرر كلمة المرور الجديدة',

  ...panelSettingsTransactionsByLang.ar,
  ...panelReferralCurrentRankMinDepositByLang.ar,
  ...panelUserExtraByLang.ar,
  ...panelDwiOverrides.ar,
  ...panelDepositBonusByLang.ar,
  ...panelVoucherStatusByLang.ar,
  ...panelWithdrawBep20ByLang.ar,
  ...panelDepositVoucherOverrides.ar,
  ...panelInvestmentsOverrides.ar,
  'user.investments.card.dailyProfit': 'الربح اليومي',
  'user.investments.card.earningDays': 'أيام العمل',
  'user.investments.card.earningDaysValue': '{{count}} يوم عمل',
  'user.investments.card.expectedProfit': 'الربح المتوقع',
  'user.investments.card.investLimit': 'حد الاستثمار',
  'user.investments.card.investLimitLine': '{{count}}× في {{days}} يومًا',
  'user.investments.card.investLimitReached':
    'لقد وصلت إلى حد الاستثمار لهذه الخطة في الفترة الحالية.',
  'user.investments.card.limitReached': 'تم بلوغ الحد',
  ...panelStopLossSlotsAssignOverrides.ar,
  ...panelStopLossFlowByLang.ar,
  ...panelUserSignupSocialForgotByLang.ar,
  ...panelAgentDashboardByLang.ar,
  ...panelAgentReferralsByLang.ar,
  ...panelAgentCommissionsByLang.ar,
  ...panelAgentWithdrawByLang.ar,
  ...panelAgentWithdrawUnlockStringsByLang.ar,
  'agent.withdraw.unlock.loadingTitle': 'جاري التحقق من حالة السحب…',
  'agent.withdraw.unlock.loadingSubtitle': 'جاري تحميل تقدم الإحالات ومتطلبات فتح السحب',
  'agent.withdraw.form.loadingTitle': 'جاري تحميل تفاصيل السحب…',
  'agent.withdraw.form.loadingHint': 'يرجى الانتظار أثناء تحميل الرصيد وحالة فتح السحب',
  'agent.withdraw.unlock.requirementMet': 'تم استيفاء الشرط',
  'agent.withdraw.unlock.minDepositHint':
    'يُحسب المستخدمون المُحالون فقط (وليس الوكلاء الفرعيون). يجب أن يكون لكل مستخدم ${{amount}} على الأقل من الإيداعات المكتملة.',
  ...panelAgentTransactionsByLang.ar,
  ...panelAgentLogsByLang.ar,
  ...panelAgentSettingsByLang.ar,
  ...panelAgentNotificationsByLang.ar,
  ...panelAgentTeamByLang.ar,
  ...panelAgentSignupByLang.ar,
  ...panelAgentLayoutByLang.ar,
  ...panelAgentAuthByLang.ar,
  ...panelUserPlatformTodayByLang.ar,
  ...panelStopLossHowLayoutByLang.ar,
  ...panelSupportTicketsByLang.ar,
});
